module.exports = __webpack_public_path__ + "static/media/5-Aquino.e81bc4fb.png";